const NUMBER_LOCALES = {
  en: "en-US",
  ru: "ru-RU",
  de: "de-DE",
  pt: "pt-BR",
  zh: "zh-CN"
};

const MASS_UNITS = {
  en: { gram: "g", kilogram: "kg", ton: "tons" },
  ru: { gram: "г", kilogram: "кг", ton: "т" },
  de: { gram: "g", kilogram: "kg", ton: "t" },
  pt: { gram: "g", kilogram: "kg", ton: "t" },
  zh: { gram: "克", kilogram: "公斤", ton: "吨" }
};

export function formatWeight(kg, locale = "en") {
  const value = Number(kg);
  const units = MASS_UNITS[locale] || MASS_UNITS.en;
  if (!Number.isFinite(value) || value <= 0) return locale === "en" ? "Unknown" : "N/A";
  if (value < 1) return `${formatNumber(Math.max(1, Math.round(value * 1000)), locale)} ${units.gram}`;
  if (value < 1000) return `${formatNumber(Math.round(value), locale)} ${units.kilogram}`;
  if (value < 1000000) return `${formatNumber(Math.round(value), locale)} ${units.kilogram}`;
  return `${formatNumber(Math.round(value / 1000), locale)} ${units.ton}`;
}

export function formatDigitalSize(sizeMb, locale = "en") {
  const value = Number(sizeMb);
  if (!Number.isFinite(value) || value <= 0) return locale === "en" ? "Unknown" : "N/A";
  if (value < 1) return `${formatNumber(Math.max(1, Math.round(value * 1024)), locale)} KB`;
  if (value < 1024) return `${formatNumber(Math.round(value), locale)} MB`;
  if (value < 1024 * 1024) return `${formatOneDecimal(value / 1024)} GB`;
  return `${formatOneDecimal(value / 1024 / 1024)} TB`;
}

export function measureValue(item) {
  return item?.measureType === "digital" ? Number(item.sizeMb) : Number(item?.weightKg);
}

export function formatItemValue(item, locale = "en") {
  return item?.measureType === "digital" ? formatDigitalSize(item.sizeMb, locale) : formatWeight(item?.weightKg, locale);
}

export function measureLabels(item, strings) {
  return item?.measureType === "digital" ? strings.measure.digital : strings.measure.mass;
}

export function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

function formatOneDecimal(value) {
  return value >= 10 ? Math.round(value).toLocaleString("en-US") : value.toFixed(1).replace(/\.0$/, "");
}

function formatNumber(value, locale) {
  return Number(value).toLocaleString(NUMBER_LOCALES[locale] || NUMBER_LOCALES.en);
}
